import { render, staticRenderFns } from "./PccOrderWarehouseAccounting.vue?vue&type=template&id=80e64cde&scoped=true&"
import script from "./PccOrderWarehouseAccounting.vue?vue&type=script&lang=js&"
export * from "./PccOrderWarehouseAccounting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e64cde",
  null
  
)

export default component.exports